// cars/my-model
import { postData } from 'src/services/RestApi';

function requestParams(values) {
  const queryData = {};
  queryData.carId = values.id;
  if(values.note){
    queryData.note = values.note;
  }

  return queryData;
}

function changeParams(values) {
  const queryData = requestParams(values);

  let pricingId = values.pricingField?.value ?? 0;
  
  // Convert object to value
  const partnerId = values.partnerField?.value ?? 0;
  if (0 < partnerId) {
    queryData.partnerId = partnerId;
    if(pricingId === 0){
      switch(partnerId){
        case 3:
          pricingId = 1;
          break;
        case 4:
          pricingId = 2;
          break;
      }
    }
  }
  if (0 < pricingId) {
    queryData.pricingId = pricingId;
  }

  if (values.cardField) {
    queryData.cardNumber = values.cardField;
  }
  const groupId = values.groupField?.value ?? 0;
  if (0 < groupId) {
    queryData.groupId = groupId;
  }
  return queryData;
}

export const apiUpdate = async (payload) => {
  
};

export const apiRemove = async (payload) => {

};

export const apiChange = async (payload) => {
  const queryData = changeParams(payload);
  return await postData('api/car/change/infors', queryData);
};